import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex justify-center items-center py-12 opacity-60" data-id="element-115">
      <div className="h-[1px] w-1/4 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent" data-id="element-116"></div>
      <div className="mx-4 w-2 h-2 rotate-45 border border-amber-500/50" data-id="element-117"></div>
      <div className="h-[1px] w-1/4 bg-gradient-to-r from-amber-500/50 via-amber-500/50 to-transparent" data-id="element-118"></div>
    </div>;
}